<div class="pnl-date-picker">
  <div class="pnl-calendars">
    <div class="pnl-month pnl-left-month">
      <app-calendar-month [month]="leftMonth" [(selectedDates)]="value" [parentForm]="parentForm"></app-calendar-month>
    </div>
    <div class="pnl-month pnl-center-month" >
      <app-calendar-month [month]="centerMonth" [(selectedDates)]="value" [parentForm]="parentForm"></app-calendar-month>
    </div>
    <div class="pnl-month pnl-right-month" >
      <app-calendar-month [month]="rightMonth" [(selectedDates)]="value" [parentForm]="parentForm"></app-calendar-month>
    </div>
  </div>
  <div class="pnl-calendar-nav">
      <a (click)="backMonth()" class="btn btn-default btn-back">
        <mat-icon>chevron_left</mat-icon>
      </a>
      <a (click)="nextMonth()" class="btn btn-default  btn-next">
        <mat-icon>chevron_right</mat-icon>
      </a>
    </div>
</div>
